// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border-left: 4px solid var(--vl-red);
  transition-duration: 0.1s;
  cursor: pointer;
}
ion-item:hover {
  --background: red !important;
}
ion-item.active-item {
  border-left: 4px solid white;
}

ion-menu ion-item {
  --min-height: 48px;
  --padding-top: 0;
  --padding-bottom: 0;
  height: 48px;
  transition: height 0.2s ease, padding 0.2s ease;
}
ion-menu ion-item ion-label {
  margin-left: 24px;
}
ion-menu ion-item ::ng-deep vl-icon path, ion-menu ion-item ::ng-deep vl-icon svg {
  fill: white !important;
}

ion-menu ion-content {
  --padding-top: 80px;
  font-size: 1.1rem;
  border-bottom: 1px solid #DDDEE3;
}

ion-footer {
  height: 70px;
}

.hide-btn-wrapper {
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
}
.hide-btn-wrapper .version-wrapper {
  margin-right: 20px;
}
.hide-btn-wrapper .hide-btn {
  margin: 0 24px;
  display: flex;
  align-items: center;
}
.hide-btn-wrapper .hide-btn ion-icon {
  font-size: 1.4rem;
}
.hide-btn-wrapper .hide-btn span {
  margin-left: 24px;
}
.hide-btn-wrapper:hover {
  background-color: red;
}

.lang-switcher {
  display: none;
}

.confirm-btn {
  color: #00a2e5;
  background-color: black !important;
  --background: black;
  --ion-color-btn: black;
  --background-activated: black;
  --background-focused: black;
  --background-hover: black;
}

.lang-switcher {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}

.version-wrapper {
  color: white;
  opacity: 0.4;
  font-size: 12px;
}

#sidebarPanel ion-menu {
  --side-max-width: 240px;
  --side-min-width: 240px;
}
#sidebarPanel ion-menu ion-item {
  height: 48px;
  --min-height: 48px;
  transition: all 0.2s ease;
}
#sidebarPanel ion-menu ion-item vl-icon {
  min-width: 24px;
  margin-left: 16px;
  margin-right: 0;
  display: flex;
  justify-content: center;
}
#sidebarPanel ion-menu ion-item ion-label {
  margin-left: 24px;
  transition: max-width 0.2s ease, opacity 0.2s ease;
  white-space: nowrap;
}
#sidebarPanel ion-menu ion-footer .hide-btn span {
  transition: opacity 0.2s ease;
}
@media (min-width: 576px) {
  #sidebarPanel.minimize ion-menu {
    --side-max-width: 70px;
    --side-min-width: 70px;
  }
  #sidebarPanel.minimize ion-menu ion-item ion-label {
    max-width: 0;
    opacity: 0;
    overflow: hidden;
  }
  #sidebarPanel.minimize ion-menu ion-item vl-icon {
    margin: 0 auto;
  }
  #sidebarPanel.minimize ion-menu ion-footer .hide-btn span {
    display: none;
  }
  #sidebarPanel.minimize ion-menu ion-footer ion-icon {
    transform: rotate(180deg);
  }
  #sidebarPanel.minimize ion-menu ion-footer ion-item ion-label {
    display: none;
  }
}
@media (max-width: 575px) {
  #sidebarPanel.minimize ion-menu {
    --side-max-width: 240px;
    --side-min-width: 240px;
  }
  #sidebarPanel.minimize ion-menu ion-item ion-label {
    max-width: 200px;
    opacity: 1;
  }
  #sidebarPanel.minimize ion-menu .hide-btn span {
    display: inline;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,yBAAA;EACA,eAAA;AACF;AAAE;EACE,4BAAA;AAEJ;AAAE;EACE,4BAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,+CAAA;AACF;AACE;EACE,iBAAA;AACJ;AAEI;EACE,sBAAA;AAAN;;AAKA;EACE,mBAAA;EACA,iBAAA;EACA,gCAAA;AAFF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AADF;AAEE;EACE,kBAAA;AAAJ;AAEE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AACI;EACE,iBAAA;AACN;AACI;EACE,iBAAA;AACN;AAEE;EACE,qBAAA;AAAJ;;AAGA;EACE,aAAA;AAAF;;AAEA;EACE,cAAA;EACA,kCAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,eAAA;AACF;;AAGE;EACE,uBAAA;EACA,uBAAA;AAAJ;AAEI;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;AAAN;AAEM;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AAAR;AAGM;EACE,iBAAA;EACA,kDAAA;EACA,mBAAA;AADR;AAKI;EACE,6BAAA;AAHN;AAQI;EACE;IACE,sBAAA;IACA,sBAAA;EANN;EASQ;IACE,YAAA;IACA,UAAA;IACA,gBAAA;EAPV;EAUQ;IACE,cAAA;EARV;EAaQ;IACE,aAAA;EAXV;EAcQ;IACE,yBAAA;EAZV;EAeQ;IACE,aAAA;EAbV;AACF;AAoBE;EAEI;IACE,uBAAA;IACA,uBAAA;EAnBN;EAqBM;IACE,gBAAA;IACA,UAAA;EAnBR;EAsBM;IACE,eAAA;EApBR;AACF","sourcesContent":["ion-item{\n  border-left: 4px solid var(--vl-red);\n  transition-duration: 0.1s;\n  cursor: pointer;\n  &:hover{\n    --background: red !important;\n  }\n  &.active-item{\n    border-left: 4px solid white;\n  }\n}\n\nion-menu ion-item {\n  --min-height: 48px;\n  --padding-top: 0;\n  --padding-bottom: 0;\n  height: 48px;\n  transition: height 0.2s ease, padding 0.2s ease;\n  \n  ion-label{\n    margin-left: 24px;\n  }\n  ::ng-deep vl-icon {\n    path, svg {\n      fill: white !important;\n    }\n  }\n}\n\nion-menu ion-content {\n  --padding-top: 80px;\n  font-size: 1.1rem;\n  border-bottom: 1px solid #DDDEE3;\n}\nion-footer{\n  height: 70px;\n}\n\n.hide-btn-wrapper{\n  cursor: pointer;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: white;\n  .version-wrapper {\n    margin-right: 20px;\n  }\n  .hide-btn{\n    margin: 0  24px;\n    display: flex;\n    align-items: center;\n    ion-icon{\n      font-size: 1.4rem;\n    }\n    span{\n      margin-left: 24px;\n    }\n  }\n  &:hover{\n    background-color: red;\n  }\n}\n.lang-switcher{\n  display: none;\n}\n.confirm-btn{\n  color: #00a2e5;\n  background-color: black !important;\n  --background: black;\n  --ion-color-btn: black;\n  --background-activated: black;\n  --background-focused: black;\n  --background-hover: black;\n}\n\n.lang-switcher{\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  height: 100%;\n}\n\n.version-wrapper {\n  color: white;\n  opacity: 0.4;\n  font-size: 12px;\n}\n\n#sidebarPanel {\n  ion-menu {\n    --side-max-width: 240px;\n    --side-min-width: 240px;\n\n    ion-item {\n      height: 48px;\n      --min-height: 48px;\n      transition: all 0.2s ease;\n\n      vl-icon {\n        min-width: 24px;\n        margin-left: 16px;\n        margin-right: 0;\n        display: flex;\n        justify-content: center;\n      }\n\n      ion-label {\n        margin-left: 24px;\n        transition: max-width 0.2s ease, opacity 0.2s ease;\n        white-space: nowrap;\n      }\n    }\n\n    ion-footer .hide-btn span {\n      transition: opacity 0.2s ease;\n    }\n  }\n\n  &.minimize {\n    @media (min-width: 576px) {\n      ion-menu {\n        --side-max-width: 70px;\n        --side-min-width: 70px;\n\n        ion-item {\n          ion-label {\n            max-width: 0;\n            opacity: 0;\n            overflow: hidden;\n          }\n\n          vl-icon {\n            margin: 0 auto;\n          }\n        }\n\n        ion-footer {\n          .hide-btn span {\n            display: none;\n          }\n\n          ion-icon {\n            transform: rotate(180deg);\n          }\n\n          ion-item ion-label {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n\n  // On mobile force full mode\n  @media (max-width: 575px) {\n    &.minimize {\n      ion-menu {\n        --side-max-width: 240px;\n        --side-min-width: 240px;\n\n        ion-item ion-label {\n          max-width: 200px;\n          opacity: 1;\n        }\n\n        .hide-btn span {\n          display: inline;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
